import React from 'react'
import { Alert, Button } from 'antd'
import { UsergroupAddOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'

import { useAppSelector } from '../../store/hooks'
import { selectAuthUserSlice } from '../../store/auth-user-slice'

import IntlMessages from '../../util/IntlMessages'

import '../../styles/components/trial-banner.less'

interface FreePlanBannerProps {
  className?: string
  sidebarCollapsed?: boolean
  visible?: boolean
}

const FreePlanBanner: React.FC<FreePlanBannerProps> = ({ className = '', sidebarCollapsed = false, visible = true }) => {
  const history = useHistory()
  const { authUser } = useAppSelector(selectAuthUserSlice)

  const handleAddUsersClick = () => {
    history.push('/app/users')
  }

  if (!visible) {
    return null
  }

  return (
    <div className={`trial-banner ${sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'} ${className}`}>
      <Alert
        type="info"
        showIcon
        icon={<UsergroupAddOutlined />}
        message={<IntlMessages id="app.freePlanBannerMessage" />}
        action={
          authUser.role === 'Admin' && (
            <Button
              size="small"
              type="link"
              onClick={handleAddUsersClick}
              className="trial-banner-action"
              aria-label="Add team members"
            >
              <IntlMessages id="app.freePlanAddUsersLink" />
            </Button>
          )
        }
        closable={false}
        className="trial-banner-alert"
        role="banner"
        aria-live="polite"
        aria-label="Free plan info banner"
      />
    </div>
  )
}

export default React.memo(FreePlanBanner)

